import { makeAutoObservable } from "mobx";
import { pagingActivityLogs } from "./ActivityLogService";
import "react-toastify/dist/ReactToastify.css";
import LocalConstants from "app/LocalConstants";

const initSearchObject = {
  keyword: "",
  logType: null,
  fromDate: "",
  toDate: "",
  moduleLog: LocalConstants.MODULE_LOG[3].value, // mặc định LKT
  //sorting
  sortLogDate: null,
  sortLogType: null,
  sortUserName: null,
  sortContentLog: null,
  sortEntityObjectType: null,
}

export default class ActivityLogStore {
  activityLogList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  loadingInitial = false;
  searchObject = {...initSearchObject};

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  updatePageData = (item) => {
    let searchObject = {
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
      sortLogDate: this.searchObject.sortLogDate,
      sortLogType: this.searchObject.sortLogType,
      sortUserName: this.searchObject.sortUserName,
      sortEntityObjectType: this.searchObject.sortEntityObjectType,
      logType: this.searchObject.logType,
      fromDate: this.searchObject.fromDate,
      toDate: this.searchObject.toDate,
      keyword: this.searchObject.keyword || "",
      moduleLog: this.searchObject?.moduleLog,
    };
    if (item != null) {
      searchObject.pageIndex = this.page = 1;
      searchObject.keyword = item.keyword;
    }
    pagingActivityLogs(searchObject).then((res) => {
      this.handleSelectPage(res)
    }).catch((error) => {
      console.error(error);
    })
  };

  handleSetSearchObject = (item) => {
    if (item.pageIndex) {
      this.page = item.pageIndex;
    }
    if(item.keyword != "") {
      this.text = item.keyword;
    }
    else{
      this.text = "";
    }
    this.searchObject = item;
  }

  handleSelectPage = (res) => {
    this.activityLogList = res?.data?.content || [];
    this.totalElements = res?.data?.totalElements || 0;
    this.totalPages = res?.data?.totalPages || 0;
  }

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  resetSearchObject = () => {
    this.searchObject = {...initSearchObject};
    this.rowsPerPage = 10;
    this.page = 1;
  }

  handleSetSortField = item => {
    this.page = 1;
    this.searchObject = {
      ...this.searchObject,
      //set các trường sort khác = null
      sortLogDate: null,
      sortLogType: null,
      sortUserName: null,
      sortContentLog: null,
      sortEntityObjectType: null,
      ...item,
    };
    this.updatePageData();
  }
}
